import { Splide } from '@splidejs/splide'
import { URLHash } from '@splidejs/splide-extension-url-hash'

export default class Stories {
    constructor() {
        this.carousel = document.querySelector('.herospace-story')
        this.instance = null
    }

    startStorySlider() {
        this.instance = new Splide( '.splide', {
            perPage: 5,
            perMove: 1,
            gap: 20,
            type: 'loop',
            speed: 200,
            trimSpace: true,
            pagination: false,
            arrows: false,
            height: 175,
            breakpoints: {
                768: {
                    perPage: 4,
                    height: 150,
                    gap: 15
                },
                500: {
                    perPage: 3,
                    height: 130,
                    gap: 10
                },
            },
        } ).mount( { URLHash } )

        const prevButton = document.getElementById('custom-prev');
        const nextButton = document.getElementById('custom-next');

        if (prevButton && nextButton) {
            prevButton.addEventListener('click', () => {
                this.instance.go('<');
            });

            nextButton.addEventListener('click', () => {
                this.instance.go('>');
            });
        }

        this.updateSlideInfo();

        this.instance.on('mounted', this.updateSlideInfo.bind(this));
        this.instance.on('moved', this.updateSlideInfo.bind(this));
    }

    createCustomArrows() {
        const arrowsContainer = document.createElement('div');
        arrowsContainer.classList.add('herospace-story__arrows');

        const prevButton = document.createElement('button');
        prevButton.id = 'custom-prev';
        prevButton.classList.add('herospace-story__arrow', 'herospace-story__arrow--prev');
        prevButton.setAttribute('aria-label', 'Előző Slide');

        const nextButton = document.createElement('button');
        nextButton.id = 'custom-next';
        nextButton.classList.add('herospace-story__arrow', 'herospace-story__arrow--next');
        nextButton.setAttribute('aria-label', 'Következő Slide');

        arrowsContainer.appendChild(prevButton);
        arrowsContainer.appendChild(nextButton);

        this.carousel.parentNode.insertBefore(arrowsContainer, this.carousel);
    }

    updateSlideInfo() {
        const currentSpan = document.querySelector('.herospace-story__info .current');
        const allSpan = document.querySelector('.herospace-story__info .all');
        const currentId = this.instance.index + 1;

        if (currentSpan && allSpan) {
            allSpan.textContent = this.instance.Components.Slides.getLength(true).toString();
            currentSpan.textContent = currentId.toString();
        }

        const stories = document.querySelectorAll('.page-stories__story');
        stories.forEach(story => {
            story.classList.remove('is-visible');
        });

        const currentStory = document.getElementById(`story-content-${currentId}`);
        if (currentStory) {
            currentStory.classList.add('is-visible');
        }
    }

    init() {
        if (this.carousel) {
            this.createCustomArrows();
            this.startStorySlider()
        }
    }
}
